/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Branches_CreateInputs */

const en_branches_create = /** @type {(inputs: Branches_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

const pt_br2_branches_create = /** @type {(inputs: Branches_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar`)
};

/**
* | output |
* | --- |
* | "Create" |
*
* @param {Branches_CreateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const branches_create = /** @type {((inputs?: Branches_CreateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Branches_CreateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_branches_create(inputs)
	return pt_br2_branches_create(inputs)
});